import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';

export const Wrapper = styled(Box)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
  ${({ theme }) => css`
    width: 100%;
    padding: ${theme.spacing(0, 2, 0, 2)};

    ${theme.media.sm.up} {
      padding: ${theme.spacing(0, 2, 0, 2)};
    }

    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 4, 0, 4)};
    }

    ${theme.media.lg.up} {
      padding: ${theme.spacing(0, 4, 0, 4)};
    }
  `}
`;

export const Title = styled(Box)<{
  $color: Maybe<string>;
  $textAlignment: Maybe<string>;
}>`
  ${({ $color, $textAlignment, theme }) =>
    css`
      font-family: ${theme.fontFamilies.italianPlate};
      font-weight: ${theme.fontWeights.bold};
      color: ${$color};
      word-break: break-word;
      font-size: ${theme.spacing(9)};
      text-align: ${$textAlignment};
      ${theme.media.md.up} {
        margin-left: ${theme.spacing(0)};
        font-size: ${theme.spacing(15)};
      }
    `}
`;

export const Text = styled(Box)<{
  $color: Maybe<string>;
  $textAlignment: Maybe<string>;
}>`
  ${({ $color, $textAlignment, theme }) =>
    css`
      font-family: ${theme.fontFamilies.italianPlate};
      font-weight: ${theme.fontWeights.bold};
      color: ${$color};
      font-size: 34px;
      word-break: break-word;
      text-align: ${$textAlignment};
      ${theme.media.md.up} {
        margin-left: ${theme.spacing(0)};
        font-size: 40px;
      }
    `}
`;
